import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _html, _markdown;

import React from 'react';
import BlockTypes from '../../../types/BlockTypes';
export default {
  html: (_html = {}, _defineProperty(_html, BlockTypes.CODES, function (_ref) {
    var attributes = _ref.attributes,
        children = _ref.children;
    return React.createElement("pre", null, React.Children.map(children, function (code) {
      return React.createElement(React.Fragment, null, code, '\n');
    }));
  }), _defineProperty(_html, BlockTypes.CODE, 'code'), _html),
  markdown: (_markdown = {}, _defineProperty(_markdown, BlockTypes.CODES, function (_ref2) {
    var node = _ref2.node,
        children = _ref2.children;
    return "```".concat(node.getIn(['nodes', 0, 'data', 'language'], ''), "\n").concat(children, "```");
  }), _defineProperty(_markdown, BlockTypes.CODE, function (_ref3) {
    var children = _ref3.children;
    return "".concat(children, "\n");
  }), _markdown)
};